/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * bundle.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import.
 */
import { modules } from "./module/modules";

/**
 * ピンチオープン禁止
 */
const html = document.querySelector('html');
html.addEventListener('touchmove', (e) => {
  e.touches.length > 1 && e.preventDefault();
}, { passive: false });

/**
 * ダブルタップによる拡大禁止
 */
document.addEventListener("dblclick", function (e) { e.preventDefault(); }, { passive: false });

/**
 * Run.
 */
modules();

/**
 * Clear console.
 */
console.clear();